import { MessageAnnotationSource, QueryAnnotationType, type QueryAnnotation, } from "@1js/sydney-types";
import type { ContentItem, ServerEmailContent, EmailConversationContent, } from "owa-bizchat-types/lib/types";
import { ContentItemType } from "owa-bizchat-types/lib/types";

function isServerEmailContent(item: ContentItem): item is ServerEmailContent {
    return item.contentType === ContentItemType.EMAIL && "id" in item;
}

function isEmailConversationContent(item: ContentItem): item is EmailConversationContent {
    return item.contentType === ContentItemType.EMAIL_CONVERSATION;
}

export function mapContentItemsToQueryAnnotations(contentItems: ContentItem[]): QueryAnnotation[] {
    const annotations: QueryAnnotation[] = [];
    
    for (const item of contentItems) {
        const annotation = mapContentItemToQueryAnnotation(item);
        if (annotation) {
            annotations.push(annotation);
        }
    }
    
    return annotations;
}

function mapContentItemToQueryAnnotation(item: ContentItem): QueryAnnotation | undefined {
    switch (item.contentType) {
        case ContentItemType.EMAIL:
            if (isServerEmailContent(item)) {
                return {
                    id: item.id,
                    text: item.subject ?? "",
                    queryAnnotationType: QueryAnnotationType.Message,
                    messageAnnotationSource: MessageAnnotationSource.ClientAnnotated,
                    messageAnnotationMetadata: {
                        "@type": QueryAnnotationType.Message,
                        mailboxInformation: item.mailboxInformation,
                    },
                };
            }
            return undefined;
        case ContentItemType.EMAIL_CONVERSATION:
            if (isEmailConversationContent(item)) {
                return {
                    id: item.id,
                    text: item.conversationTopic ?? "",
                    queryAnnotationType: QueryAnnotationType.EmailConversation,
                    messageAnnotationSource: MessageAnnotationSource.ClientAnnotated,
                    messageAnnotationMetadata: {
                        "@type": QueryAnnotationType.EmailConversation,
                        mailboxInformation: item.mailboxInformation,
                    },
                };
            }
            return undefined;
        default:
            return undefined;
    }
}
